export default __webpack_public_path__ + "images/turbo_8b45f4.svg";